module.exports = __webpack_public_path__ + "static/media/women.453f0f6a.png";